"use client"

import { Sparkles } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SparklesIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SparklesIcon = component(Icon)({ as: Sparkles })
